import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDota2Map = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M5.51226 1.3491V2.04279C5.51226 2.09752 5.46789 2.14189 5.41316 2.14189H3.38163C2.83432 2.14189 2.39064 2.58557 2.39064 3.13288V5.61036C2.39064 5.66509 2.34627 5.70946 2.29154 5.70946H1.4492C1.39447 5.70946 1.3501 5.66509 1.3501 5.61036V2.93468C1.3501 2.00426 2.10436 1.25 3.03478 1.25H5.41316C5.46789 1.25 5.51226 1.29437 5.51226 1.3491Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.48969 6.6509L2.48969 5.95721C2.48969 5.90248 2.53406 5.85811 2.58879 5.85811L4.62032 5.85811C5.16763 5.85811 5.61132 5.41443 5.61132 4.86712L5.61132 2.38964C5.61132 2.33491 5.65568 2.29054 5.71041 2.29054L6.55276 2.29054C6.60749 2.29054 6.65186 2.33491 6.65186 2.38964L6.65186 5.06532C6.65186 5.99574 5.8976 6.75 4.96717 6.75L2.58879 6.75C2.53406 6.75 2.48969 6.70563 2.48969 6.6509Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.28271 3.18237H4.7692V4.66886H3.28271V3.18237Z",
			fill: "currentColor"
		})
	]
});
export default SvgDota2Map;
